<template>
  <div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
      <k-input
      class="w-50"
      type="text"
      :name="fieldName"
      :value="value"
      @input="$emit('input',$event.target.value)"
      :placeholder="labelText
           "
    ></k-input>
   
      </div>
      </div>
  <!-- <div class="col-3">
    <label>{{labelText}}</label>

    <k-input
      class="w-100"
      type="text"
      :name="fieldName"
      :value="value"
      @input="$emit('input',$event.target.value)"
      :placeholder="labelText
           "
    ></k-input>
  </div> -->
</template>
<script>
export default {
  name: "Textbox",
  props: ["placeholder", "labelText", "fieldName", "value"]
};
</script>